import React from 'react'
import { Container, Box, Typography ,Button} from '@mui/material'
import { Privacydata } from '../assets/data'
import Footer from "../components/Footer"
import ArrowBtn from '../components/ArrowBtn'
import { Link } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import pirimg from "../assets/priviceD.png"


const Privacy = () => {
    
  const matches = useMediaQuery('(max-width:500px)');

    return (
        <>
             <Box className="Hero_main"
                style={{ backgroundImage: `url(${pirimg})`, height: matches ? '100vh' : '120vh' }} >
                <Box className="hero_div">
                    <h1 className='herotitle'>
                    WeCare <br /> Privacy Policy
                    </h1>
                    <Link to='/BookRepair'>
                        <Button variant="contained" className='herobtn1' >
                            Get a Quote
                        </Button>
                    </Link>
                </Box>
            </Box>
            <Container maxWidth="xl">
                <Box className="terms_main">

                    <Box className="termsDiv">
                        <Typography variant="body1" className='faq_desc'>Here at WeCare we know how important it is to keep your personal data safe, that’s why we’re committed to making sure that you receive the service you’d expect and that your privacy is protected every step of the way.</Typography>
                       
                        <Typography variant="body1" className='faq_desc p_top p_bot'>In this notice you’ll discover exactly what information we collect from you and how we then use it to deliver our services, as well as your rights. Please take the time to read this policy and let us know if you have any questions.</Typography>
                    
                        <Typography variant="body1" className='faq_desc'>We may change this policy by updating this page from time to time. You should check this page occasionally to ensure that you are happy with any changes. This policy is effective from 1st January 2018.</Typography>
                    </Box>

                    {Privacydata.map((item, i) => (
                        <Box className="termsDiv" key={i}>
                            <Typography variant="h5" className='faq_title'>{item.title}</Typography>
                            <Typography variant="body1" className='faq_desc'>{item.desc}</Typography>
                        </Box>
                    ))}
                </Box>
            </Container>
            <Footer/>
        </>
    )
}

export default Privacy
